@use '@/styles/tokens' as *;

// The two From/To pairs are not single <FormField>s, so each group carries its own label. Values
// map to Figma 32:190261 — label = Text/Secondary at 14, label-to-control gap = spacing/1 (4px).
// The 16px bottom margin matches <FormField>'s, so the three fields sit on one rhythm; Figma draws
// 24px, a shared-component divergence recorded in the plan rather than overridden here.
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: $font-size-md;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

// 16px between From and To, per Figma 32:190278 / 32:190266.
.row {
  display: flex;
  gap: var(--space-4);
}

// Each From/To box takes half the row. Figma 32:190279 / 32:190283 draw the input containers as
// `flex: 1 0 0` with `min-width: 1px`; `min-width: 0` is the same intent (a flex item's default
// `min-width: auto` would let the input's intrinsic size push the row wider than the drawer).
// The child here is <FormField>'s wrapper, not the input — <NumberField> already sets the antd
// InputNumber itself to `width: 100%`, so no inline style is needed on the fields.
.row > * {
  flex: 1 0 0;
  min-width: 0;
}
